import { ShieldOff, SearchX } from 'lucide-react'
import { Link } from 'react-router'
import { Button } from '@/components/ui/button'
import { t } from '@/lib/text'

function Notice({ icon: Icon, title, body, action }: { icon: typeof ShieldOff; title: string; body: string; action?: React.ReactNode }) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
      <Icon className="size-8 text-muted-foreground" aria-hidden />
      <h1 className="text-lg font-semibold">{title}</h1>
      <p className="text-muted-foreground">{body}</p>
      {action}
    </div>
  )
}

export function Forbidden() {
  return <Notice icon={ShieldOff} title={t('core.forbidden.title')} body={t('core.forbidden.body')} />
}

export function NotFound() {
  return (
    <Notice
      icon={SearchX}
      title={t('core.not_found.title')}
      body={t('core.not_found.body')}
      action={
        <Button asChild variant="outline">
          <Link to="/">{t('core.not_found.home')}</Link>
        </Button>
      }
    />
  )
}

export function ScreenError({ onRetry }: { onRetry?: () => void }) {
  return (
    <div role="alert" className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
      <h2 className="text-lg font-semibold">{t('core.common.error_title')}</h2>
      <p className="text-muted-foreground">{t('core.common.error_body')}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          {t('core.common.retry')}
        </Button>
      )}
    </div>
  )
}
